const StatusEventoEnum = {
  AGUARDANDO_APROVACAO: 0,
  APROVADO: 1,
  REPROVADO: 2,
  REFORMULADO: 3,
  VINCULADO: 4,
}

export default StatusEventoEnum
